import api from './api';

const flashDealService = {
  // Admin
  getAll: () => api.get('/admin/flash-deals').then(r => r.data),
  getNearExpiry: (hours = 48) => api.get('/admin/flash-deals/near-expiry', { params: { hours } }).then(r => r.data),
  create: (payload) => api.post('/admin/flash-deals', payload).then(r => r.data),
  update: (id, payload) => api.patch(`/admin/flash-deals/${id}`, payload).then(r => r.data),
  remove: (id) => api.delete(`/admin/flash-deals/${id}`).then(r => r.data),

  // User (logged-in)
  getActive: () => api.get('/flash-deals/active').then(r => r.data),
};

export default flashDealService;
